import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ChipsModule } from 'primeng/chips';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { MessagesModule } from 'primeng/messages';
import { PasswordModule } from 'primeng/password';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TabViewModule } from 'primeng/tabview';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { DividerModule } from 'primeng/divider';
import { MenuModule } from 'primeng/menu';
import { BadgeModule } from 'primeng/badge';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TreeSelectModule } from 'primeng/treeselect';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    InputTextModule,
    DropdownModule,
    ButtonModule,
    TableModule,
    PaginatorModule,
    DynamicDialogModule,
    InputNumberModule,
    ToggleButtonModule,
    ChipsModule,
    EditorModule,
    FileUploadModule,
    MessagesModule,
    PasswordModule,
    MultiSelectModule,
    InputTextareaModule,
    CalendarModule,
    CheckboxModule,
    TooltipModule,
    TreeModule,
    TabViewModule,
    BreadcrumbModule,
    DividerModule,
    MenuModule,
    BadgeModule,
    SplitButtonModule,
    TreeSelectModule
  ],
  exports: [
    InputTextModule,
    DropdownModule,
    ButtonModule,
    TableModule,
    PaginatorModule,
    DynamicDialogModule,
    InputNumberModule,
    ToggleButtonModule,
    ChipsModule,
    EditorModule,
    FileUploadModule,
    MessagesModule,
    PasswordModule,
    MultiSelectModule,
    InputTextareaModule,
    CalendarModule,
    CheckboxModule,
    TooltipModule,
    TreeModule,
    TabViewModule,
    BreadcrumbModule,
    DividerModule,
    MenuModule,
    BadgeModule,
    SplitButtonModule,
    TreeSelectModule
  ]
})
export class PrimeNgModule { }
